import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";
import tovLogo from "../assets/tov.jpg";
import api from '../config/api';

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE;


  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(api("/users/login"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || data.message || "Login failed. Please try again.");
        return;
      }

      localStorage.setItem("token", data.token);
      alert("Login successful!");
      navigate("/transactions");
    } catch (err) {
      console.error("Login error:", err);
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-logo">
          <img src={tovLogo} alt="TOV Logo" />
        </div>

        <h2 className="login-title">Welcome to Our Finance App 👋</h2>
        <p className="login-subtitle">Please sign in to your account to continue</p>

        <form className="login-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-remember">
            <input type="checkbox" id="remember" />
            <label htmlFor="remember">Remember Me</label>
          </div>

          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="login-button">Sign in</button>
        </form>

        <p className="login-footer">
          New on our company? <a href="#">Request an Account</a>
        </p>
      </div>
    </div>
  );
}
